"use client"

import React, { useEffect, useRef, useState } from 'react'
import styles from './style.module.css'
import { Affix, Checkbox, Col, CollapseProps, Drawer, Input, Modal, Row, Spin, Tooltip } from 'antd'
import LinkWrapper from '../../linkWrapper/page'
import { formatMsg, Helper, notification, PrefixIconButton, timeutil, attendanceActions, calendarActions, colors, permissions } from '../../..'
import { CollapseWrapper, ModalWrapper } from '../../wrapperComponents/page'
import './style.css';
import { useDispatch } from 'react-redux'
import { TimePicker } from 'antd';
import type { AttendanceBulkType, AttendanceEntityType, AttendanceOperationType, AttendanceStatus } from '../../../types/attendance'
import { useForm } from 'antd/es/form/Form'
import AbsentNoteModal from './AbsentNoteModal'
import SlotTimerPill from '../../attendance/SlotTimerPill'
import { SearchOutlined } from "@ant-design/icons";
const { resetCalendarReducer } = calendarActions;
const { getInstructorsSlotAttendance, getParticipantsSlotAttendance, resetAttendanceReducer, defaultAttendanceReducerState, markSlotBulkAttendance, resetOperationType } = attendanceActions;


const AdminViewScheduleDrawer = (props) => {

    const {
        selectedSchedule,
        scheduleDetail,
        drawerOnClose,
        isLoading,
        firebase,
        centerMap,
        teacherMap
    } = props;

    const dispatch = useDispatch();
    const [form] = useForm();


    const { attendanceReducer } = Helper.getSelectorState(["attendanceReducer"]);

    const {
        participantsAttendanceChannel,
        instructorsAttendanceChannel,
        participantsAttendanceMap,
        instructorsAttendanceMap
    } = attendanceReducer;


    const dateSlotCenterKey = selectedSchedule
        ? `${timeutil.inFormat(selectedSchedule.date, 'DD-MM-YY')}--${selectedSchedule.slotRandomId}--${selectedSchedule.centerId}`
        : '';

    const [openCollapse, setOpenCollapse] = useState<any>(['PARTICIPANT']);


    const [filteredInstructorList, setFilteredInstructorsList] = useState(undefined);
    const [instructorSearch, setInstructorSearch] = useState(undefined);

    const [filteredParticipantsList, setFilteredParticipantsList] = useState(undefined);
    const [participantSearch, setParticipantSearch] = useState(undefined);

    const [instructorAttendanceStats, setInstructorAttendanceStats] = useState(undefined);
    const [participantAttendanceStats, setParticipantAttendanceStats] = useState(undefined);


    // Whenever I change "tempParticipantsAttendanceMapRef" or "tempInstructorsAttendanceMapRef" refs
    // I use this "rerender" state to reflect map changes on UI
    const [reRenderInstructor, setReRenderInstructor] = useState(false);
    const [reRenderParticipant, setReRenderParticipant] = useState(false);

    const tempParticipantsAttendanceMapRef = useRef(new Map());
    const tempInstructorsAttendanceMapRef = useRef(new Map());


    const [instructorEditMode, setInstructorEditMode] = useState(false);
    const [participantEditMode, setParticipantEditMode] = useState(false);

    const [instructorOperationType, setInstructorOperationType] = useState<AttendanceOperationType | undefined>(undefined);
    const [participantOperationType, setParticipantOperationType] = useState<AttendanceOperationType | undefined>(undefined);

    const [showInstructorTimePicker, setShowInstructorTimePicker] = useState(undefined);
    const [showParticipantTimePicker, setShowParticipantTimePicker] = useState(undefined);

    const [instructorsBulkActionList, setInstructorBulkActionList] = useState(undefined);
    const [participantsBulkActionList, setParticipantBulkActionList] = useState(undefined);

    const [instructorBulkActionObj, setInstructorBulkActionObj] = useState(undefined);
    const [participantBulkActionObj, setParticipantBulkActionObj] = useState(undefined);

    const instructorBulkModeOn = Boolean(instructorsBulkActionList?.length > 1);
    const participantBulkModeOn = Boolean(participantsBulkActionList?.length > 1);

    const allInstructorsSelected = scheduleDetail?.instructors?.length === instructorsBulkActionList?.length;
    const allParticipantsSelected = scheduleDetail?.students?.length === participantsBulkActionList?.length;

    const [isAbsentNoteModalOpen, setIsAbsentNoteModalOpen] = useState(false);
    const [absentNoteFor, setAbsentNoteFor] = useState(undefined);
    const [absentNoteEntityType, setAbsentNoteEntityType] = useState(undefined);


    const [participantAttendanceSettings, setParticipantAttendanceSettings] = useState(undefined);
    const [instructorAttendanceSettings, setInstructorAttendanceSettings] = useState(undefined);
    // All attendance channel actions 
    const [showUnsavedChangesPopup, setShowUnsavedChangesPopup] = useState(false);

    const isFutureDate = timeutil.isFutureDate(selectedSchedule?.date);
    const canMarkStaffAttendance = permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [selectedSchedule?.centerId])
    const canMarkParticipantAttendance = canMarkStaffAttendance;
    // Same admin-only slot timer as the Attendance page.
    const showSlotTimer = process.env.NEXT_PUBLIC_WORKSPACE_NAME === "admin";

    useEffect(() => {
        return () => {
            closeParticipantsAttendanceChannel();
        }
    }, [participantsAttendanceChannel]);

    useEffect(() => {
        return () => {
            closeInstructorsAttendanceChannel();
        }
    }, [instructorsAttendanceChannel]);

    useEffect(() => {
        if (selectedSchedule) {
            closeAttendanceChannels();
            getParticipantsAttendance();
            getInstructorsAttendance();
        }
        else {
            closeAttendanceChannels();
            dispatch(resetAttendanceReducer(defaultAttendanceReducerState));
            dispatch(resetCalendarReducer({ scheduleDetail: null }));
        }
    }, [selectedSchedule]);

    useEffect(() => {
        if (firebase) {
            setParticipantAttendanceSettings(firebase.schoolConfig.studentAttendanceMode)
            setInstructorAttendanceSettings(firebase.schoolConfig.staffAttendanceMode)
        }
    }, [firebase])

    const closeAttendanceChannels = () => {
        closeParticipantsAttendanceChannel();
        closeInstructorsAttendanceChannel();
    }

    const closeParticipantsAttendanceChannel = () => {
        if (participantsAttendanceChannel) {
            participantsAttendanceChannel.close();
        }
    }

    const closeInstructorsAttendanceChannel = () => {
        if (instructorsAttendanceChannel) {
            instructorsAttendanceChannel.close();
        }
    }

    function getParticipantsAttendance() {
        dispatch(getParticipantsSlotAttendance({
            firebase,
            selectedSchedule
        }));
    }

    function getInstructorsAttendance() {
        dispatch(getInstructorsSlotAttendance({
            firebase,
            selectedSchedule
        }));
    }


    // Operation type based actions
    useEffect(() => {

        switch (attendanceReducer.operationType) {
            case 'BULK_ATTENDANCE_MARKED_SUCCESSFULLY':
                resetAllLocalStates(true);
                getInstructorsAttendance();
                getParticipantsAttendance();
                break;
            case 'BULK_ATTENDANCE_MARKING_FAILED':
                setInstructorEditMode(true);
                setParticipantEditMode(true);
                getInstructorsAttendance();
                getParticipantsAttendance();
                break;
        }
        dispatch(resetOperationType(null))

    }, [attendanceReducer.operationType])


    // Filteration logic 
    useEffect(() => {

        let tempFilteredList = scheduleDetail?.instructors || [];

        tempFilteredList = tempFilteredList.filter((instructorId) => {
            const instructorObj = teacherMap.get(instructorId) || null;
            const nameMatch = Helper.filterSearchHelper(instructorSearch, instructorObj?.name);
            return nameMatch;
        });

        setFilteredInstructorsList(tempFilteredList);

    }, [scheduleDetail?.instructors, instructorSearch, teacherMap]);

    useEffect(() => {

        let tempFilteredList = scheduleDetail?.students || [];

        tempFilteredList = tempFilteredList.filter((participantObj) => {
            const nameMatch = Helper.filterSearchHelper(participantSearch, participantObj?.name);
            return nameMatch;
        });

        setFilteredParticipantsList(tempFilteredList);

    }, [scheduleDetail?.students, participantSearch]);


    // Edit mode, "cancel" / "save" buttons visibility logic
    useEffect(() => {

        if (tempInstructorsAttendanceMapRef.current.size !== 0) {
            setInstructorEditMode(true);
        }
        else setInstructorEditMode(false);

        if (tempParticipantsAttendanceMapRef.current.size !== 0) {
            setParticipantEditMode(true);
        }
        else setParticipantEditMode(false);

    }, [reRenderInstructor, reRenderParticipant]);


    // Attendance stats calculation logic 
    useEffect(() => {

        const instructorAttendanceStats = { pending: 0, present: 0, absent: 0 };

        (scheduleDetail?.instructors || []).forEach((instructorId) => {
            const dateSlotCenterEntityKey = dateSlotCenterKey + `--${instructorId}`;

            const displayAttendanceObj = getEntityDisplayAttendanceObj('INSTRUCTOR', dateSlotCenterEntityKey);
            const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

            if (attendanceStatus === 'PENDING' || attendanceStatus === 'CLEARED') instructorAttendanceStats.pending++;
            else if (attendanceStatus === 'PRESENT') instructorAttendanceStats.present++;
            else if (attendanceStatus === 'ABSENT') instructorAttendanceStats.absent++;
        });

        setInstructorAttendanceStats(instructorAttendanceStats);

    }, [scheduleDetail?.instructors, instructorsAttendanceMap, reRenderInstructor]);

    useEffect(() => {

        const participantAttendanceStats = { pending: 0, present: 0, absent: 0 };

        (scheduleDetail?.students || []).forEach((participantObj) => {

            const dateSlotCenterEntityKey = dateSlotCenterKey + `--${participantObj.id}`;

            const displayAttendanceObj = getEntityDisplayAttendanceObj('PARTICIPANT', dateSlotCenterEntityKey);
            const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

            if (attendanceStatus === 'PENDING' || attendanceStatus === 'CLEARED') participantAttendanceStats.pending++;
            else if (attendanceStatus === 'PRESENT') participantAttendanceStats.present++;
            else if (attendanceStatus === 'ABSENT') participantAttendanceStats.absent++;
        });

        setParticipantAttendanceStats(participantAttendanceStats);

    }, [scheduleDetail?.students, participantsAttendanceMap, reRenderParticipant]);



    // Individual actions logic 

    function getIndividualReferenceTime(entityType: AttendanceEntityType, entityId: string) {
        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);

        const checkIn = displayAttendanceObj?.latestCheckIn;
        const checkOut = displayAttendanceObj?.latestCheckOut;

        if (getEntityOperationType(entityType) === 'CHECKOUT' && checkIn) {
            return timeutil.getInstance(checkIn);
        }

        if (getEntityOperationType(entityType) === 'CHECKIN' && checkOut) {
            return timeutil.getInstance(checkOut);
        }

        return null;
    }


    function getDisabledTime(
        entityType: AttendanceEntityType,
        getRefTimeFn: (entityType: AttendanceEntityType) => moment.Moment | null
    ) {
        const refTime = getRefTimeFn(entityType);
        if (!refTime) return { disabledHours: () => [], disabledMinutes: () => [] };

        const refHour = refTime.hour();
        const refMinute = refTime.minute();
        const isCheckOut = getEntityOperationType(entityType) === 'CHECKOUT';

        return {
            disabledHours: () => {
                const hours: number[] = [];
                for (let i = 0; i < 24; i++) {
                    if ((isCheckOut && i < refHour) || (!isCheckOut && i > refHour)) {
                        hours.push(i);
                    }
                }
                return hours;
            },
            disabledMinutes: (selectedHour: number) => {
                if (selectedHour !== refHour) return [];

                const minutes: number[] = [];
                for (let i = 0; i < 60; i++) {
                    if ((isCheckOut && i < refMinute) || (!isCheckOut && i > refMinute)) {
                        minutes.push(i);
                    }
                }
                return minutes;
            }
        };
    }


    function renderIndividualAttendanceActions(entityType: AttendanceEntityType, entityId: string, canMarkAttendance?: boolean) {

        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);
        const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

        const isEntityBulkModeOn = getIsEntityBulkModeOn(entityType);
        const isEntityTimePickerVisible: boolean = getIsEntityTimePickerVisible(entityType, entityId);
        const entityAttendanceSettings = getEntityAttedanceSettings(entityType);

        // If permission check is provided and user doesn't have permission, don't render individual actions
        if (canMarkAttendance === false) {
            return null;
        }

        return isEntityBulkModeOn
            ? null
            : (
                <div className={styles.attendanceActions}>
                    {
                        entityAttendanceSettings?.type === 'checkin_checkout'
                            ? isEntityTimePickerVisible
                                ? <div className={styles.timePickerContainer}>
                                    <TimePicker
                                        open={isEntityTimePickerVisible}
                                        onOpenChange={() => hideTimePicker(entityType)}
                                        value={getIndividualCheckInCheckOutValue(entityType, entityId)}
                                        onChange={(epoch, dateStr) => {
                                            onIndividualTimeChange(epoch, entityType, entityId)
                                        }}
                                        defaultOpenValue={timeutil.getInstance('00:00', 'hh:mm a')}
                                        format='hh:mm a'
                                        disabledTime={() => getDisabledTime(entityType, (et) => getIndividualReferenceTime(et, entityId))}
                                    />
                                    <div
                                        className={styles.imgContainer}
                                        onClick={() => hideTimePicker(entityType)}
                                    >
                                        <img
                                            className={styles.tickImg}
                                            src='/images/cancelGray.png'
                                        />
                                    </div>
                                </div>
                                : <div className={styles.attendanceActionsHide}>
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onIndividualPress('CHECKIN', entityType, entityId)}
                                    >
                                        <Tooltip
                                            title={formatMsg("checkIn")}
                                            rootClassName='drawer-purple-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/checkin.png'
                                            />
                                        </Tooltip>
                                    </div>
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onIndividualPress('CHECKOUT', entityType, entityId)}
                                    >
                                        <Tooltip
                                            title={formatMsg("checkOut")}
                                            rootClassName='drawer-purple-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/checkout.png'
                                            />
                                        </Tooltip>
                                    </div>
                                    {
                                        attendanceStatus === 'ABSENT'
                                            ? null
                                            : <div
                                                className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                                onClick={isFutureDate ? undefined : () => onIndividualPress('ABSENT', entityType, entityId)}
                                            >
                                                <Tooltip
                                                    title={formatMsg("markAbsent")}
                                                    rootClassName='drawer-purple-tooltip pink-tooltip'
                                                    placement="bottom"
                                                >
                                                    <img
                                                        className={styles.actionImg}
                                                        src='/images/absent.png'
                                                    />
                                                </Tooltip>
                                            </div>
                                    }
                                    {
                                        (attendanceStatus === 'PRESENT' || attendanceStatus === 'ABSENT')
                                        && <div
                                            className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                            onClick={isFutureDate ? undefined : () => onIndividualPress('CLEAR', entityType, entityId)}
                                        >
                                            <Tooltip
                                                title={formatMsg("resetAttendance")}
                                                rootClassName='drawer-purple-tooltip'
                                                placement="bottom"
                                            >
                                                <img
                                                    className={styles.actionImg}
                                                    src='/images/clear.png'
                                                />
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                            : null
                    }
                    {
                        entityAttendanceSettings?.type !== 'checkin_checkout' &&
                        <div className={styles.attendanceActionsHide}>
                            {
                                attendanceStatus === 'PRESENT'
                                    ? null
                                    : <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onIndividualPress('PRESENT', entityType, entityId)}
                                    >
                                        <Tooltip
                                            title={formatMsg("markPresent")}
                                            rootClassName='drawer-purple-tooltip green-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/present.png'
                                            />
                                        </Tooltip>
                                    </div>
                            }
                            {
                                attendanceStatus === 'ABSENT'
                                    ? null
                                    : <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onIndividualPress('ABSENT', entityType, entityId)}
                                    >
                                        <Tooltip
                                            title={formatMsg("markAbsent")}
                                            rootClassName='drawer-purple-tooltip pink-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/absent.png'
                                            />
                                        </Tooltip>
                                    </div>
                            }
                            {
                                (attendanceStatus === 'PRESENT' || attendanceStatus === 'ABSENT')
                                && <div
                                    className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                    onClick={isFutureDate ? undefined : () => onIndividualPress('CLEAR', entityType, entityId)}
                                >
                                    <Tooltip
                                        title={formatMsg("resetAttendance")}
                                        rootClassName='drawer-purple-tooltip'
                                        placement="bottom"
                                    >
                                        <img
                                            className={styles.actionImg}
                                            src='/images/clear.png'
                                        />
                                    </Tooltip>
                                </div>
                            }
                        </div>
                    }
                </div>
            )
    }

    function onIndividualPress(
        operationType: AttendanceOperationType,
        entityType: AttendanceEntityType,
        entityId: string
    ) {
        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;

        const setEntityOperationType = getEntityOperationTypeSetter(entityType);
        const setShowEntityTimePicker = getShowEntityTimePickerSetter(entityType);

        const stateAttendanceMap = getEntityStateAttendanceMap(entityType);
        const dbAttendanceMap = getEntityDBAttendanceMap(entityType);

        const attendanceInState = stateAttendanceMap.get(dateSlotCenterEntityKey) || {};
        const attendanceInDB = dbAttendanceMap.get(dateSlotCenterEntityKey) || null;

        let newAttendanceState = null;

        switch (operationType) {
            case 'CHECKIN':
            case 'CHECKOUT':
                setShowEntityTimePicker(entityId);
                break;
            case 'PRESENT':
                newAttendanceState = Helper.buildAttendanceObj(operationType, attendanceInState);
                newAttendanceState = Helper.populateAttendanceDbKeys(
                    newAttendanceState,
                    attendanceInDB,
                    entityId
                );
                stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                reRenderEntity(entityType);
                break;
            case 'ABSENT':
                newAttendanceState = Helper.buildAttendanceObj(operationType, attendanceInState);
                newAttendanceState = Helper.populateAttendanceDbKeys(
                    newAttendanceState,
                    attendanceInDB,
                    entityId
                );
                stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                reRenderEntity(entityType);

                openAbsentModal(entityType, entityId);
                break;
            case 'CLEAR':
                if (attendanceInDB) {
                    newAttendanceState = Helper.buildAttendanceObj('CLEAR', attendanceInState);
                    newAttendanceState = Helper.populateAttendanceDbKeys(
                        newAttendanceState,
                        attendanceInDB,
                        entityId
                    );
                    stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                }
                else {
                    stateAttendanceMap.delete(dateSlotCenterEntityKey);
                }
                reRenderEntity(entityType);
                break;
        }

        setEntityOperationType(operationType);
    }

    function onIndividualTimeChange(timeObj, entityType: AttendanceEntityType, entityId: string) {

        const inputEpoch = timeObj?.valueOf() || null;

        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        const operationType = getEntityOperationType(entityType);

        const stateAttendanceMap = getEntityStateAttendanceMap(entityType);
        const dbAttendanceMap = getEntityDBAttendanceMap(entityType);

        const attendanceInState = stateAttendanceMap.get(dateSlotCenterEntityKey) || {};
        const attendanceInDB = dbAttendanceMap.get(dateSlotCenterEntityKey) || null;

        const entityAttendanceSettings = getEntityAttedanceSettings(entityType);
        let newAttendanceState = null;

        switch (operationType) {
            case 'CHECKIN':
                newAttendanceState = Helper.buildAttendanceObj(
                    'CHECKIN',
                    attendanceInState,
                    { latestCheckIn: inputEpoch }
                );
                if (entityAttendanceSettings?.enableLateCheckInTracking && typeof (newAttendanceState.latestCheckIn) === 'number') {
                    newAttendanceState = Helper.checkIfCheckInLate(
                        newAttendanceState,
                        selectedSchedule?.startTime,
                        entityAttendanceSettings
                    );
                }
                newAttendanceState = Helper.populateAttendanceDbKeys(
                    newAttendanceState,
                    attendanceInDB,
                    entityId
                );
                stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                break;
            case 'CHECKOUT':
                newAttendanceState = Helper.buildAttendanceObj(
                    'CHECKOUT',
                    attendanceInState,
                    { latestCheckOut: inputEpoch }
                );
                if (entityAttendanceSettings?.enableLateCheckOutTracking && typeof (newAttendanceState.latestCheckOut) === 'number') {
                    newAttendanceState = Helper.checkIfCheckOutLate(
                        newAttendanceState,
                        selectedSchedule?.endTime,
                        entityAttendanceSettings
                    );
                }
                newAttendanceState = Helper.populateAttendanceDbKeys(
                    newAttendanceState,
                    attendanceInDB,
                    entityId
                );
                stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                break;
        }

        // Clean up when db and state all values are null 
        if (
            !newAttendanceState.latestCheckIn && !newAttendanceState.latestCheckOut &&
            !attendanceInDB?.latestCheckIn && !attendanceInDB?.latestCheckOut
        ) {
            stateAttendanceMap.delete(dateSlotCenterEntityKey);
        }

        // Hide time picker only on time selection, not on input clear 
        if (inputEpoch) hideTimePicker(entityType);

        reRenderEntity(entityType);
    }

    function getIndividualCheckInCheckOutValue(entityType: AttendanceEntityType, entityId: string) {

        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;

        let returnEpoch = null;

        let operationType: AttendanceOperationType | undefined = getEntityOperationType(entityType);
        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);

        switch (operationType) {
            case 'CHECKIN':
                returnEpoch = displayAttendanceObj?.latestCheckIn || null;
                break;
            case 'CHECKOUT':
                returnEpoch = displayAttendanceObj?.latestCheckOut || null;
                break;
        }

        return returnEpoch ? timeutil.getInstance(returnEpoch) : null;
    }


    // Bulk to non-bulk mode or non-bulk to bulk mode clean ups 

    useEffect(() => {
        // "Clear all" or "1 instructor selected" case (bulk mode to non-bulk mode)
        if ((instructorsBulkActionList?.length || 0) <= 1) {
            setInstructorBulkActionObj(undefined);
            setInstructorOperationType(undefined);
            setShowInstructorTimePicker(undefined);
        }
        // "Selected all" or "2 instructors selected" case (non-bulk mode to bulk mode)
        else if (
            instructorsBulkActionList?.length === 2 ||
            instructorsBulkActionList?.length === scheduleDetail?.instructors?.length
        ) {
            setInstructorOperationType(undefined);
            setShowInstructorTimePicker(undefined);
        }
    }, [instructorsBulkActionList]);

    useEffect(() => {
        // "Clear all" or "1 participant selected" case (bulk mode to non-bulk mode)
        if ((participantsBulkActionList?.length || 0) <= 1) {
            setParticipantBulkActionObj(undefined);
            setParticipantOperationType(undefined);
            setShowParticipantTimePicker(undefined);
        }
        // "Selected all" or "2 participants selected" case (non-bulk mode to bulk mode)
        else if (
            participantsBulkActionList?.length === 2 ||
            participantsBulkActionList?.length === scheduleDetail?.students?.length
        ) {
            setParticipantOperationType(undefined);
            setShowParticipantTimePicker(undefined);
        }
    }, [participantsBulkActionList]);


    // Bulk actions logic 
    useEffect(() => {
        if (instructorBulkModeOn && instructorBulkActionObj) {
            instructorsBulkActionList.forEach((instructorId) => {
                const dateSlotCenterEntityKey = dateSlotCenterKey + `--${instructorId}`;

                const attendanceInDB = instructorsAttendanceMap.get(dateSlotCenterEntityKey) || null;
                if (!attendanceInDB && instructorOperationType === 'CLEAR') {
                    tempInstructorsAttendanceMapRef.current.delete(dateSlotCenterEntityKey);
                }
                else {
                    let newAttendanceState = { ...instructorBulkActionObj };
                    newAttendanceState = Helper.populateAttendanceDbKeys(
                        newAttendanceState,
                        attendanceInDB,
                        instructorId
                    );

                    tempInstructorsAttendanceMapRef.current.set(
                        dateSlotCenterEntityKey,
                        newAttendanceState
                    );
                }
            });
            resetEntityOperationType('INSTRUCTOR');
            reRenderEntity('INSTRUCTOR');
        }
    }, [instructorBulkActionObj]);

    useEffect(() => {
        if (participantBulkModeOn && participantBulkActionObj) {

            participantsBulkActionList.forEach((participantId) => {
                const dateSlotCenterEntityKey = dateSlotCenterKey + `--${participantId}`;

                const attendanceInDB = participantsAttendanceMap.get(dateSlotCenterEntityKey) || null;

                if (!attendanceInDB && participantOperationType === 'CLEAR') {
                    tempParticipantsAttendanceMapRef.current.delete(dateSlotCenterEntityKey);
                }
                else {
                    let newAttendanceState = { ...participantBulkActionObj };
                    newAttendanceState = Helper.populateAttendanceDbKeys(
                        newAttendanceState,
                        attendanceInDB,
                        participantId
                    );

                    tempParticipantsAttendanceMapRef.current.set(dateSlotCenterEntityKey, newAttendanceState);
                }
            });
            resetEntityOperationType('PARTICIPANT');
            reRenderEntity('PARTICIPANT');
        }
    }, [participantBulkActionObj]);

    function getBulkReferenceTime(entityType: AttendanceEntityType) {
        const entityBulkActionObj: any = getEntityBulkActionObj(entityType);
        const operationType: AttendanceOperationType | undefined = getEntityOperationType(entityType);

        const checkIn = entityBulkActionObj?.latestCheckIn;
        const checkOut = entityBulkActionObj?.latestCheckOut;

        if (operationType === 'CHECKOUT' && checkIn) {
            return timeutil.getInstance(checkIn);
        }

        if (operationType === 'CHECKIN' && checkOut) {
            return timeutil.getInstance(checkOut);
        }

        return null;
    }

    function renderBulkAttendanceActions(entityType: AttendanceEntityType, bulkType: AttendanceBulkType, canMarkAttendance?: boolean) {

        const isEntityBulkModeOn = getIsEntityBulkModeOn(entityType);
        const isTimePickerVisible = getIsEntityTimePickerVisible(entityType, bulkType);

        const entityAttendanceSettings = getEntityAttedanceSettings(entityType);
        const dbAttendanceMap = getEntityDBAttendanceMap(entityType);

        // If permission check is provided and user doesn't have permission, don't render bulk actions
        if (canMarkAttendance === false) {
            return null;
        }

        return isEntityBulkModeOn
            ? (
                <div className={styles.attendanceActions}>
                    {
                        entityAttendanceSettings?.type === 'checkin_checkout'
                            ? isTimePickerVisible
                                ? <div className={styles.timePickerContainer}>
                                    <TimePicker
                                        open={isTimePickerVisible}
                                        onOpenChange={() => hideTimePicker(entityType)}
                                        value={getBulkCheckInCheckOutValue(entityType)}
                                        onChange={(epoch, dateStr) => {
                                            onBulkTimeChange(epoch, entityType)
                                        }}
                                        defaultOpenValue={timeutil.getInstance('00:00', 'hh:mm a')}
                                        format='hh:mm a'
                                        disabledTime={() => getDisabledTime(entityType, getBulkReferenceTime)}
                                    />
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={() => hideTimePicker(entityType)}
                                    >
                                        <img
                                            src='/images/cancelGray.png'
                                            className={styles.tickImg}
                                        />
                                    </div>
                                </div>
                                : <>
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onBulkPress('CHECKIN', entityType)}
                                    >
                                        <Tooltip
                                            title={formatMsg("checkIn")}
                                            rootClassName='drawer-purple-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/checkin.png'
                                            />
                                        </Tooltip>
                                    </div>
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onBulkPress('CHECKOUT', entityType)}
                                    >
                                        <Tooltip
                                            title={formatMsg("checkOut")}
                                            rootClassName='drawer-purple-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/checkout.png'
                                            />
                                        </Tooltip>
                                    </div>
                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onBulkPress('ABSENT', entityType)}
                                    >
                                        <Tooltip
                                            title={formatMsg("markAbsent")}
                                            rootClassName='drawer-purple-tooltip pink-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/absent.png'
                                            />
                                        </Tooltip>
                                    </div>

                                    <div
                                        className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                        onClick={isFutureDate ? undefined : () => onBulkPress('CLEAR', entityType)}
                                    >
                                        <Tooltip
                                            title={formatMsg("resetAttendance")}
                                            rootClassName='drawer-purple-tooltip'
                                            placement="bottom"
                                        >
                                            <img
                                                className={styles.actionImg}
                                                src='/images/clear.png'
                                            />
                                        </Tooltip>
                                    </div>

                                </>
                            : null
                    }
                    {
                        entityAttendanceSettings?.type !== 'checkin_checkout' &&
                        <>
                            <div
                                className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                onClick={isFutureDate ? undefined : () => onBulkPress('PRESENT', entityType)}
                            >
                                <Tooltip
                                    title={formatMsg("markPresent")}
                                    rootClassName='drawer-purple-tooltip green-tooltip'
                                    placement="bottom"
                                >
                                    <img
                                        className={styles.actionImg}
                                        src='/images/present.png'
                                    />
                                </Tooltip>
                            </div>
                            <div
                                className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                onClick={isFutureDate ? undefined : () => onBulkPress('ABSENT', entityType)}
                            >
                                <Tooltip
                                    title={formatMsg("markAbsent")}
                                    rootClassName='drawer-purple-tooltip pink-tooltip'
                                    placement="bottom"
                                >
                                    <img
                                        className={styles.actionImg}
                                        src='/images/absent.png'
                                    />
                                </Tooltip>
                            </div>

                            <div
                                className={`${styles.imgContainer} ${isFutureDate ? styles.disabled : ""}`}
                                onClick={isFutureDate ? undefined : () => onBulkPress('CLEAR', entityType)}
                            >
                                <Tooltip
                                    title={formatMsg("resetAttendance")}
                                    rootClassName='drawer-purple-tooltip'
                                    placement="bottom"
                                >
                                    <img
                                        className={styles.actionImg}
                                        src='/images/clear.png'
                                    />
                                </Tooltip>
                            </div>

                        </>
                    }
                </div>
            )
            : null
    }

    function onBulkPress(operationType: AttendanceOperationType, entityType: AttendanceEntityType) {

        const entityBulkActionObj = getEntityBulkActionObj(entityType);
        const setEntityBulkActionObj = getEntityBulkActionObjSetter(entityType);
        const setEntityOperationType = getEntityOperationTypeSetter(entityType);
        const setShowEntityTimePicker = getShowEntityTimePickerSetter(entityType);

        let newBulkActionObj = null;

        switch (operationType) {
            case 'CHECKIN':
            case 'CHECKOUT':
                setEntityOperationType(operationType);
                setShowEntityTimePicker(`BULK_${entityType}S`);
                break;

            case 'PRESENT':
                newBulkActionObj = Helper.buildAttendanceObj(operationType, entityBulkActionObj);
                setEntityBulkActionObj(newBulkActionObj);
                break;

            case 'ABSENT':
                newBulkActionObj = Helper.buildAttendanceObj(operationType, entityBulkActionObj);
                setEntityBulkActionObj(newBulkActionObj);

                openAbsentModal(entityType, `BULK_${entityType}S`);
                break;

            case 'CLEAR':
                setEntityOperationType(operationType);
                newBulkActionObj = Helper.buildAttendanceObj('CLEAR', entityBulkActionObj);
                setEntityBulkActionObj(newBulkActionObj);
                break;
        }
    }

    function onBulkTimeChange(timeObj, entityType: AttendanceEntityType) {

        const operationType: AttendanceOperationType | undefined = getEntityOperationType(entityType);
        const entityBulkActionObj = getEntityBulkActionObj(entityType);
        const setEntityBulkActionObj = getEntityBulkActionObjSetter(entityType);

        const entityAttendanceSettings = getEntityAttedanceSettings(entityType);
        const inputEpoch = timeObj?.valueOf();

        let newBulkActionObj = null;

        switch (operationType) {
            case 'CHECKIN':
                newBulkActionObj = Helper.buildAttendanceObj(
                    'CHECKIN',
                    entityBulkActionObj,
                    { latestCheckIn: inputEpoch || null }
                );
                if (entityAttendanceSettings?.enableLateCheckInTracking && typeof (newBulkActionObj.latestCheckIn) === 'number') {
                    newBulkActionObj = Helper.checkIfCheckInLate(
                        newBulkActionObj,
                        selectedSchedule?.startTime,
                        entityAttendanceSettings
                    );
                }
                setEntityBulkActionObj(newBulkActionObj);
                break;
            case 'CHECKOUT':
                newBulkActionObj = Helper.buildAttendanceObj(
                    'CHECKOUT',
                    entityBulkActionObj,
                    { latestCheckOut: inputEpoch || null }
                );
                if (entityAttendanceSettings?.enableLateCheckOutTracking && typeof (newBulkActionObj.latestCheckOut) === 'number') {
                    newBulkActionObj = Helper.checkIfCheckOutLate(
                        newBulkActionObj,
                        selectedSchedule?.endTime,
                        entityAttendanceSettings
                    );
                }
                setEntityBulkActionObj(newBulkActionObj);
                break;
        }

        // Hide time picker only on time selection, not on input clear 
        if (inputEpoch) hideTimePicker(entityType);
    }

    function getBulkCheckInCheckOutValue(entityType: AttendanceEntityType) {

        let returnEpoch = null;

        let operationType: AttendanceOperationType | undefined = getEntityOperationType(entityType);
        let entityBulkActionObj: any = getEntityBulkActionObj(entityType);

        switch (operationType) {
            case 'CHECKIN':
                returnEpoch = entityBulkActionObj?.latestCheckIn || null;
                break;
            case 'CHECKOUT':
                returnEpoch = entityBulkActionObj?.latestCheckOut || null;
                break;
        }

        return returnEpoch ? timeutil.getInstance(returnEpoch) : null;
    }


    // Absent note input taking code 

    function openAbsentModal(entityType: AttendanceEntityType, entityId: string) {
        const entityAttendanceSettings = getEntityAttedanceSettings(entityType);

        if (entityAttendanceSettings?.enableAbsentNotes) {
            setIsAbsentNoteModalOpen(true);
            setAbsentNoteEntityType(entityType);
            setAbsentNoteFor(entityId);
        }
    }

    function handleAbsentNoteOk() {

        form.validateFields()
            .then((values) => {
                const absentNote = values.absentNote || null;

                const bulkTypes = ['BULK_INSTRUCTORS', 'BULK_PARTICIPANTS'];

                // Bulk absent note 
                if (bulkTypes.includes(absentNoteFor)) {
                    const entityBulkActionObj = getEntityBulkActionObj(absentNoteEntityType);
                    const setEntityBulkActionObj = getEntityBulkActionObjSetter(absentNoteEntityType);

                    const newAttendanceState = {
                        ...entityBulkActionObj,
                        absentNote
                    };

                    setEntityBulkActionObj(newAttendanceState);
                }
                else {
                    // Individual entity absent note 
                    const dateSlotCenterEntityKey = dateSlotCenterKey + `--${absentNoteFor}`;

                    const stateAttendanceMap = getEntityStateAttendanceMap(absentNoteEntityType);
                    const attendanceInState = stateAttendanceMap.get(dateSlotCenterEntityKey) || {};

                    let newAttendanceState = {
                        ...attendanceInState,
                        absentNote
                    };

                    stateAttendanceMap.set(dateSlotCenterEntityKey, newAttendanceState);
                    reRenderEntity(absentNoteEntityType);
                }

                resetAbsentNoteStates();
            })
            .catch((error) => {
                notification("error", formatMsg("pleaseFillAllDetails"));
                console.error('Validation failed:', error);
            });
    }

    function handleAbsentNoteCancel() {
        resetAbsentNoteStates();
    }

    function resetAbsentNoteStates() {

        form.resetFields();

        setIsAbsentNoteModalOpen(false);
        setAbsentNoteEntityType(undefined);
        setAbsentNoteFor(undefined);
    }

    // Entity Based General functions 

    function reRenderEntity(entityType: AttendanceEntityType): void {

        switch (entityType) {
            case 'INSTRUCTOR':
                setReRenderInstructor(prev => !prev);
                break;
            case 'PARTICIPANT':
                setReRenderParticipant(prev => !prev);
                break;
        }
    }

    function getEntityAttedanceSettings(entityType: AttendanceEntityType) {

        let entityAttendanceSettings = null;

        switch (entityType) {
            case 'INSTRUCTOR':
                entityAttendanceSettings = instructorAttendanceSettings;
                break;
            case 'PARTICIPANT':
                entityAttendanceSettings = participantAttendanceSettings;
                break;
        }

        return entityAttendanceSettings;
    }

    function getEntityStateAttendanceMap(entityType: AttendanceEntityType) {

        let stateAttendanceMap = null;

        switch (entityType) {
            case 'INSTRUCTOR':
                stateAttendanceMap = tempInstructorsAttendanceMapRef.current;
                break;
            case 'PARTICIPANT':
                stateAttendanceMap = tempParticipantsAttendanceMapRef.current;
                break;
        }

        return stateAttendanceMap;
    }

    function getEntityDBAttendanceMap(entityType: AttendanceEntityType) {

        let dbAttendanceMap = null;

        switch (entityType) {
            case 'INSTRUCTOR':
                dbAttendanceMap = instructorsAttendanceMap;
                break;
            case 'PARTICIPANT':
                dbAttendanceMap = participantsAttendanceMap;
                break;
        }

        return dbAttendanceMap;
    }

    function getEntityDisplayAttendanceObj(
        entityType: AttendanceEntityType,
        dateSlotCenterEntityKey: string
    ) {

        const stateAttendanceMap = getEntityStateAttendanceMap(entityType);
        const dbAttendanceMap = getEntityDBAttendanceMap(entityType);

        const attendanceInState = stateAttendanceMap.get(dateSlotCenterEntityKey) || null;
        const attendanceInDB = dbAttendanceMap.get(dateSlotCenterEntityKey) || null;

        const displayAttendanceObj = (attendanceInState || attendanceInDB)
            ? {
                ...(attendanceInDB || {}),
                ...(attendanceInState || {})
            }
            : null;

        return displayAttendanceObj;
    }

    function hideTimePicker(entityType: AttendanceEntityType) {

        resetShowEntityTimePicker(entityType);
        resetEntityOperationType(entityType);
    }

    function resetShowEntityTimePicker(entityType: AttendanceEntityType) {

        const setShowEntityTimePicker = getShowEntityTimePickerSetter(entityType);
        setShowEntityTimePicker(undefined);
    }

    function resetEntityOperationType(entityType: AttendanceEntityType) {

        const setEntityOperationType = getEntityOperationTypeSetter(entityType);
        setEntityOperationType(undefined);
    }

    function getEntityOperationType(
        entityType: AttendanceEntityType
    ): AttendanceOperationType | undefined {

        let operationType: AttendanceOperationType | undefined = undefined;

        switch (entityType) {
            case 'INSTRUCTOR':
                operationType = instructorOperationType;
                break;
            case 'PARTICIPANT':
                operationType = participantOperationType;
                break;
        }

        return operationType;
    }

    function getEntityOperationTypeSetter(
        entityType: AttendanceEntityType
    ) {

        let setEntityOperationType: any = undefined;

        switch (entityType) {
            case 'INSTRUCTOR':
                setEntityOperationType = setInstructorOperationType;
                break;
            case 'PARTICIPANT':
                setEntityOperationType = setParticipantOperationType;
                break;
        }

        return setEntityOperationType;
    }

    function getShowEntityTimePickerSetter(
        entityType: AttendanceEntityType
    ) {

        let setShowEntityTimePicker: any = undefined;

        switch (entityType) {
            case 'INSTRUCTOR':
                setShowEntityTimePicker = setShowInstructorTimePicker;
                break;
            case 'PARTICIPANT':
                setShowEntityTimePicker = setShowParticipantTimePicker;
                break;
        }

        return setShowEntityTimePicker;
    }

    function getIsEntityInEditMode(entityType: AttendanceEntityType) {

        let editMode = false;

        switch (entityType) {
            case 'INSTRUCTOR':
                editMode = instructorEditMode;
                break;
            case 'PARTICIPANT':
                editMode = participantEditMode;
                break;
        }

        return editMode;
    }

    function getIsEntityBulkModeOn(entityType: AttendanceEntityType) {

        let bulkModeOn = false;

        switch (entityType) {
            case 'INSTRUCTOR':
                bulkModeOn = instructorBulkModeOn;
                break;
            case 'PARTICIPANT':
                bulkModeOn = participantBulkModeOn;
                break;
        }

        return bulkModeOn;
    }

    function getEntityBulkActionObj(entityType: AttendanceEntityType) {

        let entityBulkActionObj = undefined;

        switch (entityType) {
            case 'INSTRUCTOR':
                entityBulkActionObj = instructorBulkActionObj;
                break;
            case 'PARTICIPANT':
                entityBulkActionObj = participantBulkActionObj;
                break;
        }

        return entityBulkActionObj;
    }

    function getEntityBulkActionObjSetter(entityType: AttendanceEntityType) {

        let entityBulkActionObjSetter = undefined;

        switch (entityType) {
            case 'INSTRUCTOR':
                entityBulkActionObjSetter = setInstructorBulkActionObj;
                break;
            case 'PARTICIPANT':
                entityBulkActionObjSetter = setParticipantBulkActionObj;
                break;
        }

        return entityBulkActionObjSetter;
    }

    function getIsEntityTimePickerVisible(
        entityType: AttendanceEntityType,
        validValue: string
    ): boolean {

        let stateValue = '';

        switch (entityType) {
            case 'INSTRUCTOR':
                stateValue = showInstructorTimePicker;
                break;
            case 'PARTICIPANT':
                stateValue = showParticipantTimePicker;
                break;
        }

        const isTimePickerVisible = stateValue === validValue;

        return isTimePickerVisible;
    }

    function getEntityAttendanceStatsObj(entityType: AttendanceEntityType) {

        let statsObj = null;

        switch (entityType) {
            case 'INSTRUCTOR':
                statsObj = instructorAttendanceStats;
                break;
            case 'PARTICIPANT':
                statsObj = participantAttendanceStats;
                break;
        }

        return statsObj;
    }

    function getAttendanceStats(entityType: AttendanceEntityType) {

        if (!permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [selectedSchedule?.centerId])) {
            return null;
        }
        const entityAttendanceStatsObj = getEntityAttendanceStatsObj(entityType);

        return (
            <div className={styles.headerSubText}>
                {(entityAttendanceStatsObj?.present || 0) + ' Present'}
                <span className={styles.dot} />
                {(entityAttendanceStatsObj?.absent || 0) + ' Absent'}
                <span className={styles.dot} />
                {(entityAttendanceStatsObj?.pending || 0) + ' Pending'}
            </div>
        )
    }


    function getParticipantSlotTimer(participantId: string) {
        if (!showSlotTimer || !selectedSchedule) return null;
        if (!permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [selectedSchedule?.centerId])) {
            return null;
        }
        const displayAttendanceObj = getEntityDisplayAttendanceObj('PARTICIPANT', dateSlotCenterKey + `--${participantId}`);
        return (
            <SlotTimerPill
                record={selectedSchedule}
                attendance={displayAttendanceObj}
                status={Helper.getAttendanceStatus(displayAttendanceObj)}
                settings={participantAttendanceSettings}
            />
        );
    }

    function getEntityAttendanceStatus(entityType: AttendanceEntityType, entityId: string) {
        if (!permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [selectedSchedule?.centerId])) {
            return null;
        }
        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);
        const isEntityInEditMode = getIsEntityInEditMode(entityType);

        const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

        if (attendanceStatus === 'PRESENT') {

            const checkInTs = displayAttendanceObj.latestCheckIn;
            const checkOutTs = displayAttendanceObj.latestCheckOut;

            if (!checkInTs && !checkOutTs) {
                return <div className={styles.presentStatus}>
                    {formatMsg('present')}
                </div>
            }

            const checkInTime = checkInTs
                ? timeutil.getInstance(displayAttendanceObj.latestCheckIn).format("hh:mm A")
                : formatMsg('small.pending');
            const checkOutTime = checkOutTs
                ? timeutil.getInstance(displayAttendanceObj.latestCheckOut).format("hh:mm A")
                : formatMsg('small.pending');


            const checkInLabel = `${displayAttendanceObj.lateIn ? formatMsg('lateIn') : formatMsg('capital.in')} ${checkInTime}`;
            const checkOutLabel = `${displayAttendanceObj.lateOut ? formatMsg('lateOut') : formatMsg('out')} ${checkOutTime}`;

            return (
                <div className={styles.checkInCheckOutStatus}>
                    <span className={displayAttendanceObj.lateIn ? styles.lateText : checkInTime === formatMsg('small.pending') ? styles.pendingText : styles.withoutLateText}>
                        {checkInLabel}
                    </span>
                    <span className={displayAttendanceObj.lateOut ? styles.lateText : checkOutTime === formatMsg('small.pending') ? styles.pendingText : styles.withoutLateText}>
                        {" - " + checkOutLabel}
                    </span>
                </div>
            )
        }
        else if (attendanceStatus === 'ABSENT') {
            return <div className={styles.absentStatus}> {formatMsg('absent')} </div>;
        }
        else if (isEntityInEditMode) {
            return <div className={styles.pendingStatus}> {formatMsg('pending')} </div>;
        }
    }

    function getEntityAttendanceStatusIcon(entityType: AttendanceEntityType, entityId: string) {
        if (!permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [selectedSchedule?.centerId])) {
            return null;
        }
        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        let isEntityInEditMode = getIsEntityInEditMode(entityType);

        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);
        const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

        if (attendanceStatus === 'PRESENT') {
            return (
                <div className={styles.attendanceStatusIcon}>
                    <img
                        src='/images/greenTickV2.png'
                        className={styles.tickImg}
                    />
                </div>
            );
        }
        else if (attendanceStatus === 'ABSENT') {
            return (
                <div className={styles.attendanceStatusIcon}>
                    <img
                        src='/images/redCrossV2.png'
                        className={styles.tickImg}
                    />
                </div>
            )
        }
        else if (isEntityInEditMode) {
            return (
                <div className={styles.attendanceStatusIcon}>
                    <img
                        src='/images/yellowExclaimation.png'
                        className={styles.tickImg}
                    />
                </div>
            )
        }
    }

    // Participants only; records saved before the marker existed were all made by staff.
    function getMarkedByLabel(entityId: string) {
        if (!permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [selectedSchedule?.centerId])) {
            return null;
        }
        const displayAttendanceObj = getEntityDisplayAttendanceObj('PARTICIPANT', dateSlotCenterKey + `--${entityId}`);
        const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);
        if (attendanceStatus !== 'PRESENT' && attendanceStatus !== 'ABSENT') return null;
        return (
            <div className={styles.markedBy} data-testid="attendance-marked-by">
                {formatMsg(displayAttendanceObj.markedByType === 'PARENT' ? 'markedByParent' : 'markedByStaff')}
            </div>
        );
    }

    function getAbsentNote(entityType: AttendanceEntityType, entityId: string) {

        const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
        const displayAttendanceObj = getEntityDisplayAttendanceObj(entityType, dateSlotCenterEntityKey);

        if (displayAttendanceObj?.absentNote) {
            const note = displayAttendanceObj.absentNote;
            const isTruncated = note.length > 20;
            const displayedNote = isTruncated ? `${note.slice(0, 20)}...` : note;
            return <div className={styles.absentNote}>
                {isTruncated ? (
                    <Tooltip title={note}>
                        <span>{displayedNote}</span>
                    </Tooltip>
                ) : (
                    <span>{displayedNote}</span>
                )}
            </div>
        }

        return null;
    }

    function selectDeselectAll(entityType: AttendanceEntityType) {

        switch (entityType) {
            case 'INSTRUCTOR':
                if (allInstructorsSelected) setInstructorBulkActionList(undefined);
                else {
                    const instructorIds = scheduleDetail?.instructors || [];
                    setInstructorBulkActionList(instructorIds);
                }
                break;
            case 'PARTICIPANT':
                if (allParticipantsSelected) setParticipantBulkActionList(undefined);
                else {
                    const studentIds = scheduleDetail?.students?.map((participantObj) => participantObj.id) || [];
                    setParticipantBulkActionList(studentIds);
                }
                break;
        }
    }


    function onCancel() {
        resetAllLocalStates(true);
    }

    function onSubmit() {

        closeAttendanceChannels();

        setInstructorEditMode(false);
        setParticipantEditMode(false);

        dispatch(markSlotBulkAttendance({
            firebase,
            payload: {
                selectedSchedule,
                tempInstructorsAttendanceMap: tempInstructorsAttendanceMapRef.current,
                tempParticipantsAttendanceMap: tempParticipantsAttendanceMapRef.current
            }
        }));
    }

    function onDrawerClose() {
        if (instructorEditMode || participantEditMode) {
            setShowUnsavedChangesPopup(true);
        } else {
            drawerOnClose && drawerOnClose();
            resetAllLocalStates();
        }
    }



    // Reseting local states 
    function resetAllLocalStates(dontReset = false) {

        if (!dontReset) {
            setOpenCollapse(['PARTICIPANT']);

            setFilteredInstructorsList(undefined);
            setFilteredParticipantsList(undefined);

            setInstructorSearch(undefined);
            setParticipantSearch(undefined);
        }

        setInstructorAttendanceStats(undefined);
        setParticipantAttendanceStats(undefined);

        setInstructorOperationType(undefined);
        setParticipantOperationType(undefined);

        setInstructorBulkActionList(undefined);
        setParticipantBulkActionList(undefined);

        setInstructorBulkActionObj(undefined);
        setParticipantBulkActionObj(undefined);

        setShowInstructorTimePicker(undefined);
        setShowParticipantTimePicker(undefined);

        setInstructorEditMode(false);
        setParticipantEditMode(false);

        tempInstructorsAttendanceMapRef.current = new Map();
        tempParticipantsAttendanceMapRef.current = new Map();

        reRenderEntity('INSTRUCTOR');
        reRenderEntity('PARTICIPANT');
        setShowUnsavedChangesPopup(false);
    }

    // All UI Rendering Functions 

    function getInstructorLabel() {

        return (
            <div >
                <div className={styles.headerContainer}>
                    <div>
                        <img
                            src='/images/singleUser.png'
                            className={styles.singleUserImg}
                        />
                    </div>
                    <div className={styles.headerText}>
                        <div>
                            {scheduleDetail?.instructors?.length || 0}
                        </div>
                        <div>
                            {formatMsg("instructors")}
                        </div>
                    </div>
                </div>
                {
                    isFutureDate
                        ? <div className={styles.headerSubText}>
                            {formatMsg("markingAttendanceNotAvailableYet")}
                        </div>
                        : canMarkStaffAttendance
                            ? getAttendanceStats('INSTRUCTOR')

                            : <div className={styles.attendanceStatsContainer}>
                                {getAttendanceStats('INSTRUCTOR')}
                                <div className={styles.headerWarningMsg} >
                                    {formatMsg("youDon'tHavePermissionToMarkAttendance")}
                                </div>
                            </div>
                }
            </div>
        )
    }

    function renderNoSearchResults() {
        return (
            <div className={styles.noParticipantsCont} data-testid='drawer-no-search-results'>
                <div className={styles.noParticipantsText}>
                    {formatMsg('noResultsFound')}
                </div>
            </div>
        )
    }

    function getInstructorsChildren() {

        return (
            <div>
                {
                    Boolean(scheduleDetail?.instructors?.length)
                        ?
                        <>
                            <div className={styles.instructorsTopSection}>
                                <Input
                                    className='attn-search attn-search-outlined'
                                    placeholder={formatMsg("searchInstructors")}
                                    value={instructorSearch}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setInstructorSearch(e.target.value);
                                    }}
                                    suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    style={{
                                        width: "250px",
                                        marginBottom: (!canMarkStaffAttendance || isFutureDate) ? "15px" : "0px"
                                    }}
                                />
                            </div>

                            {/* Search stays visible on no match so it can be cleared. */}
                            {filteredInstructorList?.length === 0 && renderNoSearchResults()}
                            {Boolean(filteredInstructorList?.length) && <>
                            <div className={styles.instructorsTopSection}>
                                {
                                    canMarkStaffAttendance && !isFutureDate &&
                                    <Checkbox
                                        checked={allInstructorsSelected}
                                        onClick={() => selectDeselectAll('INSTRUCTOR')}
                                        className={`${styles.selectAll} attn-ckbox`}
                                    >
                                        {'  '}{allInstructorsSelected ? formatMsg('deselectAll') : formatMsg('selectAll')}
                                    </Checkbox>
                                }
                                {
                                    canMarkStaffAttendance &&
                                    renderBulkAttendanceActions('INSTRUCTOR', 'BULK_INSTRUCTORS',
                                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [selectedSchedule?.centerId])
                                    )
                                }
                            </div>
                            <Checkbox.Group
                                value={instructorsBulkActionList}
                                onChange={(val) => {
                                    setInstructorBulkActionList(val);
                                }}
                                style={{ width: '100%' }}
                                className='admin-drawer-checkbox-grp'
                            >
                                <Row gutter={[0, 14]} className={`attn-scrollable-container ${(participantEditMode || instructorEditMode) ? " attn-scrollable-container-edit-mode " : ""}`}>
                                    {
                                        filteredInstructorList.map((teacherId, key) => {
                                            const teacher = teacherMap.get(teacherId) || {};
                                            const renderTeacherContent = () => (
                                                <div className={styles.userData}>
                                                    <div className={styles.imgContainer}>
                                                        <img
                                                            className={styles.profileIcon}
                                                            src={Helper.getProfileImageUrl(teacher)}
                                                            alt={`${teacher.name}'s profile`}
                                                        />
                                                        {getEntityAttendanceStatusIcon('INSTRUCTOR', teacher.id)}
                                                    </div>
                                                    <div className={styles.dataContainer}>
                                                        <div className={styles.userDesc}>
                                                            <div className={styles.subheaderRegular}>
                                                                {teacher.name}
                                                            </div>
                                                        </div>
                                                        <div className={styles.attendanceStatus}>
                                                            {getEntityAttendanceStatus('INSTRUCTOR', teacher.id)}
                                                        </div>
                                                        {getAbsentNote('INSTRUCTOR', teacher.id)}
                                                    </div>
                                                </div>
                                            );
                                            return (
                                                <>
                                                    <div key={key} className={styles.teacherRowWrapper}>
                                                        <Col span={17} key={key}>
                                                            {
                                                                (canMarkStaffAttendance && !isFutureDate)
                                                                    ? (
                                                                        <Checkbox
                                                                            value={teacher.id}
                                                                            className='attn-ckbox'
                                                                        >
                                                                            {renderTeacherContent()}
                                                                        </Checkbox>
                                                                    )
                                                                    : (
                                                                        renderTeacherContent()
                                                                    )
                                                            }
                                                        </Col>
                                                        <Col span={7}>
                                                            <div className={`${styles.entityContainer}`}>
                                                                {
                                                                    canMarkStaffAttendance &&
                                                                    renderIndividualAttendanceActions('INSTRUCTOR', teacher.id,
                                                                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [selectedSchedule?.centerId])
                                                                    )
                                                                }
                                                            </div>
                                                        </Col>
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                </Row>
                            </Checkbox.Group>
                            </>}
                        </>
                        : <div className={styles.noParticipantsCont}>
                            <img
                                src="/images/noParticipantsV2.png"
                                className={styles.noParticipantsImg}
                            />
                            <div className={styles.noParticipantsText}>
                                {formatMsg('noInstructors')}
                            </div>
                        </div>
                }
            </div>
        )
    }

    function getParticipantsLabel() {
        return (
            <div>
                <div className={styles.headerContainer}>
                    <div>
                        <img
                            src='/images/twoUsers.png'
                            className={styles.twoUsersImg}
                        />
                    </div>
                    <div className={styles.headerText}>
                        <div>
                            {scheduleDetail?.students?.length || 0}
                        </div>
                        <div>
                            {
                                (firebase?.schoolConfig?.useUserTypeAsDisplayName && firebase?.schoolConfig?.selectedUserTypeName)
                                    ? firebase?.schoolConfig?.selectedUserTypeName
                                    : formatMsg('users')
                            }
                        </div>
                    </div>
                </div>
                {
                    isFutureDate
                        ? <div className={styles.headerSubText}>
                            {formatMsg("markingAttendanceNotAvailableYet")}
                        </div>

                        : canMarkParticipantAttendance
                            ? getAttendanceStats('PARTICIPANT')
                            : <div className={styles.attendanceStatsContainer}>
                                {getAttendanceStats('PARTICIPANT')}
                                <div className={styles.headerWarningMsg}>
                                    {formatMsg("youDon'tHavePermissionToMarkAttendance")}
                                </div>
                            </div>
                }
            </div>
        )
    }

    function getParticipantsChildren() {
        return (
            <div>
                {
                    Boolean(scheduleDetail?.students?.length)
                        ? <>
                            <div className={styles.participantsTopSection}>

                                <Input
                                    className='attn-search attn-search-outlined'
                                    placeholder={Helper.getSelectedUserTypeName(firebase, formatMsg("searchParticipants"), formatMsg('search'), null, "LOWERCASE")}
                                    value={participantSearch}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setParticipantSearch(e.target.value);
                                    }}
                                    suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    style={{
                                        width: "250px",
                                        marginBottom: (!canMarkStaffAttendance || isFutureDate) ? "15px" : "0px"
                                    }}

                                />

                            </div>

                            {/* Search stays visible on no match so it can be cleared. */}
                            {filteredParticipantsList?.length === 0 && renderNoSearchResults()}
                            {Boolean(filteredParticipantsList?.length) && <>
                            <div className={styles.participantsTopSection}>
                                {
                                    canMarkParticipantAttendance && !isFutureDate &&
                                    <Checkbox
                                        checked={allParticipantsSelected}
                                        onClick={() => selectDeselectAll('PARTICIPANT')}
                                        className={`${styles.selectAll} attn-ckbox`}
                                    >
                                        {'  '}{allParticipantsSelected ? formatMsg('deselectAll') : formatMsg('selectAll')}
                                    </Checkbox>
                                }
                                {
                                    canMarkParticipantAttendance &&
                                    renderBulkAttendanceActions('PARTICIPANT', 'BULK_PARTICIPANTS',
                                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [selectedSchedule?.centerId])
                                    )
                                }
                            </div>
                            <Checkbox.Group
                                value={participantsBulkActionList}
                                onChange={(val) => {
                                    setParticipantBulkActionList(val);
                                }}
                                style={{ width: '100%' }}
                                className='admin-drawer-checkbox-grp'
                            >
                                <Row gutter={[0, 14]} className={`attn-scrollable-container ${(participantEditMode || instructorEditMode) ? " attn-scrollable-container-edit-mode " : ""}`}>
                                    {
                                        filteredParticipantsList.map((accountObj, key) => {
                                            const renderParticipantContent = () => (
                                                <div className={styles.userData}>
                                                    <div className={styles.imgContainer}>
                                                        <img
                                                            className={styles.profileIcon}
                                                            src={Helper.getProfileImageUrl(accountObj)}
                                                        />
                                                        {
                                                            getEntityAttendanceStatusIcon(
                                                                'PARTICIPANT',
                                                                accountObj.id
                                                            )
                                                        }
                                                    </div>
                                                    <div className={styles.dataContainer}>
                                                        <div className={styles.userDesc}>
                                                            <div className={styles.subheaderRegular}>
                                                                {accountObj.name}
                                                            </div>
                                                        </div>
                                                        <div className={`${styles.attendanceStatus} ${styles.statusWithSlotTimer}`}>
                                                            {
                                                                getEntityAttendanceStatus(
                                                                    'PARTICIPANT',
                                                                    accountObj.id
                                                                )
                                                            }
                                                            {getParticipantSlotTimer(accountObj.id)}
                                                        </div>
                                                        {getAbsentNote('PARTICIPANT', accountObj.id)}
                                                        {getMarkedByLabel(accountObj.id)}
                                                    </div>
                                                </div>
                                            )
                                            return (
                                                <>
                                                    <div key={key} className={styles.teacherRowWrapper}>
                                                        <Col span={17} key={key}>
                                                            {
                                                                (canMarkParticipantAttendance && !isFutureDate)
                                                                    ? (
                                                                        <Checkbox
                                                                            value={accountObj.id}
                                                                            className='attn-ckbox'
                                                                        >
                                                                            {renderParticipantContent()}
                                                                        </Checkbox>
                                                                    )
                                                                    : (
                                                                        renderParticipantContent()
                                                                    )
                                                            }
                                                        </Col>
                                                        <Col span={7}>
                                                            <div className={`${styles.entityContainer} ${styles.hideOnIdle}`}>
                                                                {
                                                                    canMarkParticipantAttendance &&
                                                                    renderIndividualAttendanceActions('PARTICIPANT', accountObj.id,
                                                                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [selectedSchedule?.centerId])
                                                                    )
                                                                }
                                                            </div>
                                                        </Col>
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                </Row>
                            </Checkbox.Group>
                            </>}
                        </>
                        : <div className={styles.noParticipantsCont}>
                            <img
                                src="/images/noParticipantsV2.png"
                                className={styles.noParticipantsImg}
                            />
                            <div className={styles.noParticipantsText}>
                                {Helper.getSelectedUserTypeName(firebase, formatMsg("noParticipants"), formatMsg('no'), null, "LOWERCASE")}
                            </div>
                        </div>
                }
            </div>
        )
    }

    return (
        <Drawer
            className='admin-schedule-drawer'
            open={Boolean(selectedSchedule)}
            onClose={onDrawerClose}
            width={650}
            closable={false}
            title={
                <div
                    className={styles.drawerHeader}
                    onClick={onDrawerClose}
                >
                    <div className={styles.packageBatchContainer}>
                        <LinkWrapper
                            href={''}
                            target='_blank'
                        >
                            <div className={styles.packageName}>
                                {selectedSchedule?.packageName}
                            </div>
                            <div className={styles.batchName}>
                                {selectedSchedule?.batchName}
                            </div>
                        </LinkWrapper>
                    </div>
                    <div className={styles.blackCrossContainer}>
                        <img
                            src='/images/black-cross.png'
                            className={styles.blackCross}
                        />
                    </div>
                </div>
            }
            footer={
                (participantEditMode || instructorEditMode) ? (
                    <Row
                        gutter={[10, 10]}
                        align="middle"
                        justify="space-around"
                    >
                        <Col span={8}>
                            <PrefixIconButton
                                title={formatMsg('cancel')}
                                width="100%"
                                height="40px"
                                border={true}
                                fontColor="var(--primary-color)"
                                borderColor="1px solid var(--primary-color)"
                                borderRadius="8px"
                                onClick={() => setShowUnsavedChangesPopup(true)}
                            />
                        </Col>
                        <Col span={8}>
                            <PrefixIconButton
                                type="primary"
                                title={formatMsg('save')}
                                width="100%"
                                height="40px"
                                border={true}
                                borderColor="1px solid var(--primary-color)"
                                borderRadius="8px"
                                onClick={onSubmit}
                            />
                        </Col>
                    </Row>
                ) : null
            }
        >
            <Spin
                spinning={isLoading || attendanceReducer.isLoading}
            >

                <div className={styles.infoCard}>
                    <div className={styles.infoContainer}>
                        <div>
                            <img
                                src='/images/scheduleTime.png'
                                className={styles.scheduleTimeIcon}
                            />
                        </div>
                        {
                            selectedSchedule &&
                            <div className={styles.infoValue}>
                                {timeutil.getInstance(selectedSchedule?.date).format('dddd')}
                                {', '}
                                {timeutil.getInstance(selectedSchedule?.date).format(Helper.dateFormat(firebase))}
                                <span className={styles.dot} />
                                {timeutil.getInstance(selectedSchedule?.startTime).format(Helper.timeFormat(firebase))}
                                {' - '}
                                {timeutil.getInstance(selectedSchedule?.endTime).format(Helper.timeFormat(firebase))}
                            </div>
                        }
                    </div>
                    {
                        firebase.schoolConfig.showPackageActivities && Boolean(selectedSchedule?.activityName) &&
                        <div className={styles.infoContainer}>
                            <div>
                                <img
                                    src='/images/activityIcon.png'
                                    className={styles.calendarIcon}
                                />
                            </div>
                            <div className={styles.infoValue}>
                                {selectedSchedule?.activityName}
                            </div>
                        </div>
                    }
                    {
                        Boolean(selectedSchedule?.days) &&
                        <div className={styles.infoContainer}>
                            <div>
                                <img
                                    src='/images/calendarV2.png'
                                    className={styles.calendarIcon}
                                />
                            </div>
                            <div className={styles.infoValue}>
                                {Helper.getWeeksDisplayText(selectedSchedule?.days)}
                            </div>
                        </div>
                    }
                    <div className={styles.infoContainer}>
                        <div>
                            <img
                                src='/images/locationGray.png'
                                className={styles.locationIcon}
                            />
                        </div>
                        {
                            selectedSchedule && centerMap?.get(selectedSchedule?.centerId) &&
                            <div className={styles.infoValue}>
                                {centerMap.get(selectedSchedule.centerId).name}
                            </div>
                        }
                    </div>
                </div>

                <div className='attn-drawer-horizontal-divider' ></div>


                <CollapseWrapper
                    className={`attendance-collapse${(participantEditMode || instructorEditMode) ? " edit-mode-on" : ""}`}
                    activeKey={openCollapse}
                    onChange={(key) => setOpenCollapse(key)}
                    ghost
                    accordion
                    expandIconPosition="end"
                >
                    <CollapseWrapper.Panel key="INSTRUCTOR" header={getInstructorLabel()}>
                        {getInstructorsChildren()}
                    </CollapseWrapper.Panel>
                    <div className="attn-drawer-horizontal-divider" />
                    <CollapseWrapper.Panel key="PARTICIPANT" header={getParticipantsLabel()}>
                        {getParticipantsChildren()}
                    </CollapseWrapper.Panel>
                </CollapseWrapper>

                <AbsentNoteModal
                    form={form}
                    isAbsentNoteModalOpen={isAbsentNoteModalOpen}
                    handleAbsentNoteOk={handleAbsentNoteOk}
                    handleAbsentNoteCancel={handleAbsentNoteCancel}
                />

                <ModalWrapper
                    open={showUnsavedChangesPopup}
                    onCancel={() => setShowUnsavedChangesPopup(false)}
                    maskClosable={false}
                    footer={
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 15, marginTop: 20 }}>
                            <PrefixIconButton
                                title={formatMsg("no")}
                                backgroundColor={colors.color_white}
                                fontColor={colors.color_purple}
                                onClick={() => setShowUnsavedChangesPopup(false)}
                            />
                            <PrefixIconButton
                                title={formatMsg("yes")}
                                border={true}
                                backgroundColor={colors.color_purple}
                                fontColor={colors.color_white}
                                onClick={onCancel}
                                borderRadius="4px"
                            />
                        </div>
                    }
                    closable={false}
                    width={480}
                >
                    <div className={styles.cancelPopup}>
                        {formatMsg("unsaveWithoutSavingChanges")}
                    </div>
                </ModalWrapper>

            </Spin>
        </Drawer >
    )
}

export default AdminViewScheduleDrawer;